
import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Icon } from '@/components/ui/icon';

import { Button } from '@/components/ui/button';

interface FormFieldsProps {
  email: string;
  setEmail: (email: string) => void;
  password: string;
  setPassword: (password: string) => void;
  isSubmitting: boolean;
}

const FormFields: React.FC<FormFieldsProps> = ({
  email,
  setEmail,
  password,
  setPassword,
  isSubmitting,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="space-y-5">
      <div className="space-y-3">
        <div className="space-y-2">
          <Label htmlFor="email" className="text-sm font-medium text-gray-700 dark:text-gray-200">Email</Label>
          <div className="relative">
            <Input 
              id="email" 
              type="email" 
              placeholder="you@example.com" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="pl-10 h-11 bg-white/30 dark:bg-white/10 backdrop-blur-sm border border-accent/20 focus:border-accent/40 focus-visible:border-accent/40 hover:border-accent/30 hover:shadow-md transition-all duration-300 shadow-sm"
              required
              disabled={isSubmitting}
              autoComplete="email"
            />
            <Icon 
              name="Mail" 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-accent" 
              size={18}
            />
          </div>
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="password" className="text-sm font-medium text-gray-700 dark:text-gray-200">Password</Label>
          <div className="relative">
            <Input 
              id="password" 
              type={showPassword ? "text" : "password"}
              placeholder="••••••••" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="pl-10 h-11 bg-white/30 dark:bg-white/10 backdrop-blur-sm border border-accent/20 focus:border-accent/40 focus-visible:border-accent/40 hover:border-accent/30 hover:shadow-md transition-all duration-300 shadow-sm"
              required
              disabled={isSubmitting}
              minLength={6}
              autoComplete="new-password"
            />
            <Icon 
              name="Lock" 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-accent" 
              size={18}
            />
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="absolute right-1 top-1/2 transform -translate-y-1/2 h-8 w-8 p-0"
              disabled={isSubmitting}
              onClick={() => setShowPassword(!showPassword)}
            >
              <Icon 
                name={showPassword ? "EyeOff" : "Eye"} 
                className="text-accent" 
                size={18}
              />
            </Button>
          </div>
        </div>
      </div>

      {/* Captcha is now shared at the AuthPage level */}
    </div>
  );
};

export default FormFields;
